//导入axios
// import axios from "axios";
import axiosRequest from '@/utils/axios-default-request'

//配置axios接口
//post

// 获取登录用户信息
let getLoginUserDataObj = data =>
  axiosRequest.postBody('/supinterface/getSupUserData', data)

//获取用户基本信息 getSupInfoBasicsData
let getSupInfoData = data =>
  axiosRequest.postBody('/supinterface/getSupInfoData', data)

//用户头像上传
let uploadUserAvatar = data =>
  axiosRequest.postBodyJson('/supinterface/upAvatar', data)

//文件上传
let uploadFile = data => axiosRequest.postFile('/supinterface/uploadFile', data)

//文件下载
let downloadFile = data =>
  axiosRequest.postFile('/supinterface/downloadFile', data)

//删除文件
let deleteFile = data => axiosRequest.postBody('/supinterface/deleteFile', data)

//提示完善个人基本信息 getWsgrxxtx
let getWsgrxxtx = data =>
  axiosRequest.postBody('/supinterface/getWsgrxxtx', data)

//提示完善个人基本信息 getWsgrxxtxJS
let getWsgrxxtxJS = data =>
  axiosRequest.postBody('/supinterface/getWsgrxxtxJS', data)

//提示完善个人简历信息 getGrjlxx
let getGrjlxx = data => axiosRequest.postBody('/supinterface/getGrjlxx', data)

//获取概览页消息通知数量
let getUnreadMsg = data =>
  axiosRequest.postBody('/supinterface/getUnreadMsg', data)

export default {
  getSupInfoData, //获取用户基本信息
  uploadUserAvatar, //头像上传
  getLoginUserDataObj, //获取登录用户信息
  uploadFile, //文件上传接口,
  downloadFile, //文件下载
  deleteFile, //删除文件
  getWsgrxxtx, //提示完善个人基本信息
  getWsgrxxtxJS,//提示完善个人基本信息--只有结算的时候使用
  getGrjlxx, //提示完善个人简历信息
  getUnreadMsg //概览页消息通知
}
